import { useMutation } from "@apollo/client";

import { GqlClientUserAssignRoleInput, gql } from "~/__generated__";

import { CLIENT_USER_GET_ALL_WITH_ACCESS_TO_CLIENT } from "./useClientUserGetAllWithAccessToClient";

const CLIENT_USER_ASSIGN_ROLE = gql(`
    mutation ClientUserAssignRole($input: GqlClientUserAssignRoleInput!) {
        clientUserAssignRole(input: $input) {
            id
        }
    }
`);

export default function useClientUserAssignRole() {
    const [mutate, { loading, error, data }] = useMutation(CLIENT_USER_ASSIGN_ROLE, {
        refetchQueries: [CLIENT_USER_GET_ALL_WITH_ACCESS_TO_CLIENT],
    });

    const assignRole = (clientId: string, input: Omit<GqlClientUserAssignRoleInput, "clientId">) =>
        mutate({
            variables: {
                input: {
                    ...input,
                    clientId,
                },
            },
        });

    return {
        assignRole,
        loading,
        error,
        updatedUser: data?.clientUserAssignRole,
    };
}
